export default __webpack_public_path__ + "static/media/aacx.54f92eea.jpg";